import { styled } from '@mui/material';
import { StyledPopoverBox } from '../PopoverBox/PopoverBox.style';

export const StyledAccountSettings = styled(StyledPopoverBox)`
  width: 25rem;
`;
